if (!customElements.get('sticky-atc-panel')) {
  class StickyAtcPanel extends HTMLElement {
    constructor() {
      super();

      this.productSection = this.closest('.cc-main-product');
      this.productInfo = this.productSection.querySelector('.product-info');
      this.productForm = this.productSection.querySelector('product-form');

      if ('IntersectionObserver' in window && 'MutationObserver' in window) {
        this.bindEvents();
      }
    }

    // eslint-disable-next-line class-methods-use-this
    disconnectedCallback() {
      window.removeEventListener('scroll', StickyAtcPanel.handleScroll);
    }

    bindEvents() {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.target === this.productForm && !theme.mediaMatches.md) {
            this.classList.toggle('sticky-atc-panel--out', entry.boundingClientRect.bottom > 0);
          } else if (entry.target === this.productInfo && theme.mediaMatches.md) {
            this.classList.toggle('sticky-atc-panel--out', entry.isIntersecting);
          }
        });
      });

      if (this.productForm) observer.observe(this.productForm);
      if (this.productInfo) observer.observe(this.productInfo);

      window.addEventListener('scroll', StickyAtcPanel.handleScroll);
    }

    /**
     * Watches for a scroll to the bottom of the page
     */
    static handleScroll() {
      document.body.classList.toggle(
        'scrolled-to-bottom',
        window.scrollY + window.innerHeight + 100 > document.body.scrollHeight
      );
    }
  }

  customElements.define('sticky-atc-panel', StickyAtcPanel);
}

// 2026-08-18: sticky juostos "I krepseli" mygtukas.
// Nekuriam atskiros /cart/add formos - trigerinam pagrindini formos mygtuka,
// kad nesidubliuotu krepselio logika (drawer, kiekis, klaidu apdorojimas).
document.addEventListener('click', (event) => {
  const trigger = event.target.closest('[data-sticky-add]');
  if (!trigger) return;
  const section = trigger.closest('.cc-main-product');
  const mainButton = section && section.querySelector('product-form [name="add"]');
  if (mainButton) mainButton.click();
});

// 2026-08-26: variantines prekes - variantas renkamas TIESIOG juostoje.
// Juostos dropdownas ir pagrindinis variantu pasirinkiklis sinchronizuojami abiem kryptim,
// kad "I krepseli" visada idetu tai, ka zmogus mato juostoje.
(function () {
  function initStickyVariants() {
    document.querySelectorAll('sticky-atc-panel').forEach(function (panel) {
      var section = panel.closest('.cc-main-product');
      if (!section) return;
      var addBtn = panel.querySelector('[data-sticky-add]');
      var chooseLink = panel.querySelector('[data-sticky-choose]');
      var select = panel.querySelector('[data-sticky-variant-select]');
      var label = panel.querySelector('[data-sticky-variant]');
      var idInput = section.querySelector('product-form [name="id"]');
      if (!idInput) return;

      function syncPrice() {
        var main = section.querySelector('.product-info .price, product-info .price');
        var bar = panel.querySelector('.price');
        if (main && bar && main.innerHTML && bar.innerHTML !== main.innerHTML) {
          bar.innerHTML = main.innerHTML;
        }
      }

      // --- prekes su vienu pasirinkimu (dropdownas juostoje) ---
      if (select) {
        // juosta -> pagrindinis pasirinkiklis
        select.addEventListener('change', function () {
          var opt = select.options[select.selectedIndex];
          // kataloge dalis opciju su kainos priedu ("5m +22.00 EUR") - lyginam tik varianto dali
          var val = opt ? (opt.getAttribute('data-opt') || '').split(' +')[0].trim() : '';
          if (!val) return;
          var radios = section.querySelectorAll('variant-picker input[type="radio"]');
          var hit = null;
          radios.forEach(function (r) {
            var rv = (r.value || '').split(' +')[0].trim();
            if (!hit && rv === val) hit = r;
          });
          if (hit) {
            hit.checked = true;
            hit.dispatchEvent(new Event('change', { bubbles: true }));
          } else {
            var native = section.querySelector('variant-picker select');
            if (native) {
              for (var i = 0; i < native.options.length; i++) {
                if ((native.options[i].value || '').split(' +')[0].trim() === val) {
                  native.selectedIndex = i;
                  native.dispatchEvent(new Event('change', { bubbles: true }));
                  break;
                }
              }
            }
          }
          setTimeout(syncPrice, 150);
        });

        // pagrindinis pasirinkiklis -> juosta
        section.addEventListener('change', function (e) {
          if (e.target === select) return;
          setTimeout(function () {
            var id = idInput.value;
            for (var i = 0; i < select.options.length; i++) {
              if (select.options[i].value === id) { select.selectedIndex = i; break; }
            }
            syncPrice();
          }, 80);
        });

        syncPrice();
        return;
      }

      // --- prekes su keliomis opcijomis: paliekam "Pasirinkti", kol neapsisprendes ---
      if (!chooseLink || !addBtn) { syncPrice(); return; }
      var startId = idInput.value;
      function variantLabel() {
        var checked = section.querySelector('variant-picker input[type="radio"]:checked');
        if (checked && checked.value) return checked.value.split(' +')[0].trim();
        var sel = section.querySelector('variant-picker select');
        if (sel && sel.selectedOptions && sel.selectedOptions[0]) {
          return sel.selectedOptions[0].textContent.split(' +')[0].trim();
        }
        return '';
      }
      function apply() {
        var chosen = /[?&]variant=/.test(window.location.search) || idInput.value !== startId;
        chooseLink.hidden = chosen;
        addBtn.hidden = !chosen;
        if (label) {
          var t = chosen ? variantLabel() : '';
          label.textContent = t;
          label.hidden = !t;
        }
        syncPrice();
      }
      apply();
      section.addEventListener('change', function () { setTimeout(apply, 60); });
      try {
        new MutationObserver(apply).observe(idInput, { attributes: true, attributeFilter: ['value'] });
      } catch (e) {}
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initStickyVariants);
  } else {
    initStickyVariants();
  }
})();
